import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.scss';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ScrollToTop from './Components/ScrollToTop';
import Header from './Components/Header';
import Footer from './Components/Footer';
import Home from './Pages/Home';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import Login from './Pages/Login';
import MyAccount from './Pages/MyAccount';


function App() {
  return (
    <div className="App">
      <Header />
      <ScrollToTop />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/polityka-prywatnosci" element={<PrivacyPolicy />} />
          <Route path="/login" element={<Login />} />
          <Route path="/moje-konto" element={<MyAccount />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
